/*
 * @Author: your name
 * @Date: 2022-03-16 16:11:51
 * @LastEditTime: 2022-03-17 17:46:45
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /saas-home/src/api/index.js
 */
import { axios } from '@/utils/request'

const api = {
  QuerySystemExtListForSub: '/sso/subjectServiceSystemExt/querySystemExtListForSub',
  PlatformUniteInterface: '/sso/ThirdInterface/platformUniteInterface', // 平台系统通用接口的请求转发
  GetAnnouncementYhEjectDetail: '/sso/announcementGroup/getAnnouncementYhEjectDetail',
  getLastAnnouncement: '/sso/announcementGroup/getLastAnnouncement',
  getAnnouncementNotice: '/sso/announcementGroup/getAnnouncementNotice',
  // QueryMenuStatus: '/sso/menu/queryMenuStatus', // 获取用户状态
  AddMenuStatus: '/sso/menu/addMenuStatus', // 保存用户状态
  RecordMenuOpt: '/sso/menuStatistics/recordMenuOpt', // 统计点击次数
  NoticeThirdSystemClearCache: '/sso/serviceInfo/noticeThirdSystemClearCache', // 通知第三方清除缓存
  DownloadImg: '/upload/download', // 下载
  QuerySystemParamsPage: '/sso/systemParams/querySystemParamsPage',
  checkSelMuchJump: '/sso/subjectServiceSystemExt/checkSelMuchJump',
  queryRenewNotice: '/sso/subjectServiceSystemExt/queryRenewNotice', // 获取即将用完提醒
  bannerList: '/openApi/banner/queryList',
  queryThirdAppSimple: '/openApi/apiAppInfo/queryThirdAppSimple',
  forward: '/sso/forward', // 资金转发接口
  queryMsgNoticePage: '/sso/msgNotice/queryMsgNoticePage', // 获取消息通知分页
  GetAccountStatusList: '/sso/ThirdInterface/getAccountStatusList', // 账号店铺管理列表
  queryClassification: '/sso/messageManagement/queryClassification', // 查询消息分类
  getNoticeMuteTime: '/sso/msgNotice/getNoticeMuteTime', // 获取消息免打扰时间
  BuildStationStatusInterface: '/sso/ThirdInterface/buildStationStatusInterface', // C端免费建站表单提交
  AddMenuScoreInfo: '/sso/menuStatistics/addMenuScoreInfo', // 添加菜单反馈及培训信息
  QueryPageBindDocument: '/sso/pageDocumentRelation/queryPageBindDocument',
  // QueryMenuScoreSwitch: '/sso/menuStatistics/queryMenuScoreSwitch' // 查询反馈功能隐藏状态
  RenewalReminder: '/sso/serviceInfo/renewalReminder', // 续费提醒
  stTopSaledGoods: process.env.VUE_APP_EXTERNAL_API + '/external-data/query-company' // TOP50商品
}

export default api
export const querySystemExtListForSub = async params => axios.post(api.QuerySystemExtListForSub, params)
export const PlatformUniteInterface = async params => axios.post(api.PlatformUniteInterface, params)
export const GetAnnouncementYhEjectDetail = async params => axios.post(api.GetAnnouncementYhEjectDetail, params)
export const getLastAnnouncement = async params => axios.post(api.getLastAnnouncement, params)
// export const queryMenuStatus = async params => axios.post(api.QueryMenuStatus, params)
export const addMenuStatus = async params => axios.post(api.AddMenuStatus, params, { async: false })
export const recordMenuOpt = async (params) => axios.post(api.RecordMenuOpt, params)
export const noticeThirdSystemClearCache = async (params) => axios.post(api.NoticeThirdSystemClearCache, params)
export const DownloadImg = async params => axios.post(api.DownloadImg, params, { responseType: 'blob' })
export const QuerySystemParamsPage = async params => axios.post(api.QuerySystemParamsPage, params)
export const checkSelMuchJump = async params => axios.post(api.checkSelMuchJump, params)
export const bannerList = async params => axios.post(api.bannerList, params)
export const forward = async params => axios.post(api.forward, params)
export const queryMsgNoticePage = async params => axios.post(api.queryMsgNoticePage, params, false)
export const getNoticeMuteTime = async params => axios.post(api.getNoticeMuteTime, params, false)
export const GetAccountStatusList = async params => axios.post(api.GetAccountStatusList, params, false)
export const BuildStationStatusInterface = async params => axios.post(api.BuildStationStatusInterface, params, false)
export const queryClassification = async params => axios.post(api.queryClassification, params, false)
export const AddMenuScoreInfo = async params => axios.post(api.AddMenuScoreInfo, params, false)
// export const QueryMenuScoreSwitch = async params => axios.post(api.QueryMenuScoreSwitch, params, false)
export const getAnnouncementNotice = async params => axios.post(api.getAnnouncementNotice, params, false)
export const queryRenewNotice = async params => axios.post(api.queryRenewNotice, params, false)
export const QueryPageBindDocument = async params => axios.post(api.QueryPageBindDocument, params, false)
export const queryThirdAppSimple = async params => axios.post(api.queryThirdAppSimple, params, false)
export const RenewalReminder = async params => axios.post(api.RenewalReminder, params)
export const getGuideProgress = async params => axios.post(api.getGuideProgress, params, false)
export const stTopSaledGoods = async (params, headers) => axios.get(api.stTopSaledGoods, { params, headers });
